import { render, staticRenderFns } from "./NavigationMobile.vue?vue&type=template&id=fb53a12e&scoped=true"
import script from "./NavigationMobile.vue?vue&type=script&lang=js"
export * from "./NavigationMobile.vue?vue&type=script&lang=js"
import style0 from "./NavigationMobile.vue?vue&type=style&index=0&id=fb53a12e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb53a12e",
  null
  
)

export default component.exports